export default __webpack_public_path__ + "static/media/comments-icon.f0dec963.svg";